module.exports = __webpack_public_path__ + "img/30.2bac4852.png";